import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  image: string;
  rating: number;
  year: number;
  category: string;
  updateInfo: string;
  tags?: string[];
}

export default function MovieCard({ id, title, image, rating, year, category, updateInfo, tags }: MovieCardProps) {
  const categoryLabel = category === 'movie' ? '电影' : category === 'tv' ? '电视剧' : '动漫';

  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3 bg-background-200">
        <img
          src={image}
          alt={title}
          title={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-white whitespace-nowrap">
            {rating}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <span className="text-xs text-white/90 bg-black/40 px-2 py-0.5 rounded whitespace-nowrap">
            {updateInfo}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs rounded bg-secondary-500 text-white whitespace-nowrap">
            {categoryLabel}
          </span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1 font-heading">
        {title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{year}</span>
        {tags && tags.length > 0 && (
          <>
            <span className="text-foreground-300">|</span>
            <span className="text-foreground-500 whitespace-nowrap">{tags.slice(0, 2).join(' ')}</span>
          </>
        )}
      </div>
    </Link>
  );
}